module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmYzMzE5IiBkPSJNMTcwLjY2NCAwaDM0MS4zM3YyNTUuOTkyaC0zNDEuMzN6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDBjYzI4IiBkPSJNMTcwLjY2NCAyNTUuOTkyaDM0MS4zM3YyNTUuOTkyaC0zNDEuMzN6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDE3MC42NjR2NTExLjk4NEgweiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/mg.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/mg.svg
// module chunks = 0